import { Alert, Box } from "@mui/material";
import { useTranslation } from "react-i18next";

import { GqlObservationValidationStatusError } from "~/__generated__";

interface ValidationStatusAlertProps {
    errors: GqlObservationValidationStatusError[];
}

export function ValidationStatusAlert({ errors }: ValidationStatusAlertProps) {
    const { t, i18n } = useTranslation("mapEditor");

    return (
        <Alert color="warning" variant="outlined">
            <span>{t("featureDetailObservation.validationStatusAlert.title")}</span>

            <Box component="ul" sx={{ listStyleType: "circle", paddingInline: 2, marginTop: 1, marginBottom: 0 }}>
                {errors.map(element => {
                    const relevantKey = element.path[element.path.length - 1];
                    const i18nKey = `featureDetailObservation.${relevantKey}`;

                    return (
                        <Box component="li" key={relevantKey}>
                            {i18n.exists(i18nKey, { ns: "mapEditor" }) ? t(i18nKey) : relevantKey}
                        </Box>
                    );
                })}
            </Box>
        </Alert>
    );
}
